import {
  EventEmitter,
  Input,
  Output,
  TemplateRef
} from '@angular/core';

import { Action } from '../action/action';
import { FilterEvent } from '../filter/filter-event';
import { PaginationEvent } from '../pagination/pagination-event';
import { SortEvent } from '../sort/sort-event';
import { ToolbarView } from '../toolbar/toolbar-view';
import { TableEvent } from './table-event';

/**
 * Table base
 */
export abstract class TableBase {
  /**
   * The name of the toolbar template containing actions
   */
   actionTemplate: TemplateRef<any>;

  /**
   * The name of the toolbar template containing views
   */
   viewTemplate: TemplateRef<any>;

  /**
   * The event emitted when a row has been dragged and dropped
   */
   onDrop = new EventEmitter();

  /**
   * The Event is emitted when Page Size is changed -- requires paginationConfig
   *
   * Not applicable with ngx-datatable page event
   */
   onPageSizeChange = new EventEmitter();

  /**
   * The Event is emitted when Page Number is Changed -- requires paginationConfig
   *
   * Not applicable with ngx-datatable page event
   */
   onPageNumberChange = new EventEmitter();

  /**
   * The event emitted when an action (e.g., button, kebab, etc.) has been selected -- requires toolbarConfig
   */
   onActionSelect = new EventEmitter();

  /**
   * The event emitted when a field menu option is selected -- requires toolbarConfig
   */
   onFilterFieldSelect = new EventEmitter();

  /**
   * The event emitted when a filter has been changed -- requires toolbarConfig
   */
   onFilterChange = new EventEmitter();

  /**
   * The event emitted when a filter has been saved -- requires toolbarConfig
   */
   onFilterSave = new EventEmitter();

  /**
   * The event emitted when the user types ahead in the query input field -- requires toolbarConfig
   */
   onFilterTypeAhead = new EventEmitter();

  /**
   * The event emitted when an item selection has been changed -- requires showCheckbox
   *
   * Not applicable with ngx-datatable select event
   */
   onSelectionChange = new EventEmitter();

  /**
   * The event emitted when the sort has changed -- requires toolbarConfig
   *
   * Not applicable with ngx-datatable sort event
   */
   onSortChange = new EventEmitter();

  /**
   * The event emitted when a view has been selected -- requires toolbarConfig
   */
   onViewSelect = new EventEmitter();

  /**
   * The default constructor
   */
  constructor() {
  }

  // Private

  protected handleAction($event: Action) {
    this.onActionSelect.emit($event);
  }

  protected handleFilterChange($event: FilterEvent) {
    this.onFilterChange.emit($event);
  }

  protected handleFilterFieldSelect($event: FilterEvent) {
    this.onFilterFieldSelect.emit($event);
  }

  protected handleFilterTypeAhead($event: FilterEvent) {
    this.onFilterTypeAhead.emit($event);
  }

  protected handleFilterSave($event: FilterEvent) {
    this.onFilterSave.emit($event);
  }

  protected handlePageSize($event: PaginationEvent) {
    this.onPageSizeChange.emit($event);
  }

  protected handlePageNumber($event: PaginationEvent) {
    this.onPageNumberChange.emit($event);
  }

  protected handleSelectionChange($event: TableEvent) {
    this.onSelectionChange.emit($event);
  }

  protected handleSortChange($event: SortEvent) {
    this.onSortChange.emit($event);
  }

  protected handleViewSelect($event: ToolbarView) {
    this.onViewSelect.emit($event);
  }
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'actionTemplate': [{ type: Input },],
'viewTemplate': [{ type: Input },],
'onDrop': [{ type: Output, args: ['onDrop', ] },],
'onPageSizeChange': [{ type: Output, args: ['onPageSizeChange', ] },],
'onPageNumberChange': [{ type: Output, args: ['onPageNumberChange', ] },],
'onActionSelect': [{ type: Output, args: ['onActionSelect', ] },],
'onFilterFieldSelect': [{ type: Output, args: ['onFilterFieldSelect', ] },],
'onFilterChange': [{ type: Output, args: ['onFilterChange', ] },],
'onFilterSave': [{ type: Output, args: ['onFilterSave', ] },],
'onFilterTypeAhead': [{ type: Output, args: ['onFilterTypeAhead', ] },],
'onSelectionChange': [{ type: Output, args: ['onSelectionChange', ] },],
'onSortChange': [{ type: Output, args: ['onSortChange', ] },],
'onViewSelect': [{ type: Output, args: ['onViewSelect', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
